import i18n from "components/i18n/i18n";
import $ from "jquery";
import { ColumnDefinition } from "../columns/ColumnDefinitions";
import { NumberColumn } from "../columns/NumberColumn";
import { Table, TableDefinition } from "../table";
import { TableAdditionInline } from "./tableAdditionInline";
import { TableRestrictionDataModel } from "../columns/data/tableRestrictionDataModel";

export interface FooterCellDefinition {
    row?: number;
    col: number;
    colspan?: number;
    labelKey?: string;
    columnDefinition?: ColumnDefinition;

}

export class TableFooter {
    public static renderFooter(
        tableView: JQuery<HTMLElement>, 
        tableDefinition: TableDefinition, 
        table: Table, 
        restrictionsDataModel: TableRestrictionDataModel) {
        const tableFootView = $("<tfoot>");
        TableAdditionInline.renderAddition(table, tableFootView[0], restrictionsDataModel);
        if (tableDefinition.footer != null) {
            let rowCount = this.getNumRows(tableDefinition.footer);
            for (let j = 0; j <= rowCount; j++) {
                let rowView = $("<tr>");
                rowView.appendTo(tableFootView);
                for (let i = 0; i < table.dataColumns.length; i++) {
                    let footerCell = tableDefinition.footer.find((c) => c.col === i && c.row === j);
                    if (footerCell != null) {
                        let htmlCeldas = "";
                        htmlCeldas += "<th data-column-index=" + i;
                        if (footerCell.colspan != null && footerCell.colspan > 1) {
                            htmlCeldas += " colspan='" + footerCell.colspan + "'";
                            // se saltan las siguientes celdas que va a ocupar el row
                            i += footerCell.colspan - 1;
                        }
                        htmlCeldas += ">";
                        if (footerCell.labelKey != null) {
                            htmlCeldas += "<div style='text-align:right;'>" + i18n.instance.t(footerCell.labelKey) + "</div>";
                        }
                        $(htmlCeldas).appendTo(rowView);
                    } else {
                        $("<th data-column-index=" + i + ">").appendTo(rowView);
                    }
                }
            }
        }
        tableFootView.appendTo(tableView);
    }


    private static getNumRows(footerDefinition: FooterCellDefinition[]) {
        let rows = 0;
        for (let definition of footerDefinition) {
            rows = Math.max(rows, definition.row);
        }
        return rows;
    }

    public static setFooterValue(definition: FooterCellDefinition[], dataTable: DataTables.Api, footerData: any) {
        if (definition != null) {
            if (footerData == null) {
                console.warn("No data for the footer", this);
                return;
            }
            let footer = dataTable.tables().footer();
            for (let footerCell of definition) {
                if (footerCell.columnDefinition != null) {
                    let viewCell = $(footer)
                        .find("tr:nth-of-type(" + (footerCell.row + 1) + ")"
                            + " > th[data-column-index=" + (footerCell.col) + "]");
                    if (footerCell.columnDefinition.type === "NumberColumn") {
                        let col = new NumberColumn(null, footerCell.columnDefinition);
                        // Datatables only initializes the first row of the table
                        // In SISLOG we need multiple row footers
                        viewCell.addClass(col.className);
                        let rawData = footerData[footerCell.columnDefinition.property];
                        let cellData;
                        if (rawData == null) {
                            cellData = null;
                        } else {
                            cellData = col.render(rawData, "display", null);
                        }
                        viewCell.text(cellData);
                    } else {
                        viewCell.text("data");
                    }
                }
            }
        }
    }
}
